import { ActionReducerMap } from '@ngrx/store';
import * as t from './reducers';
export const featureKey = 'data-filter';

export interface DataFilterFeatureState {
  dataFilter: t.DataFilterState;
  filterPanel: t.FilterPanelState;
}

export const reducers: ActionReducerMap<DataFilterFeatureState> = {
  dataFilter: t.dataFilterReducer,
  filterPanel: t.filterPanelReducer,
};
